module.exports = __webpack_public_path__ + "img/日出_sunrise.d16ee5d9.png";